import React from 'react'

function UsageLog() {
  return (
    <div>
      Usage Log
    </div>
  )
}

export default UsageLog
